import * as React from 'react';
import { Box, Button, TextButton, Divider, Card, Text } from '@wix/design-system';
import { generateAmountText, generateAppliedToText, generateOrderSubtotalText } from './utils';
import { CREATE_SERVICE_FEE_WIDGET_NAME } from './consts';
export const CreateServiceFee = _ref => {
  let {
    data: {
      serviceFee,
      saveServiceFeeButtonText = 'Save Service Fee',
      cancelButtonText = 'Cancel'
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const {
    confirmMessage,
    cancelMessage,
    data
  } = serviceFee;
  const {
    name,
    feeAmount: {
      price: amount,
      currencyOrPercentage
    },
    applyBasedOnFulfillmentTypes,
    applyBasedOnSubtotal,
    siteProperties: {
      currency
    }
  } = data;
  const amountText = generateAmountText(currencyOrPercentage, amount, currency);
  const appliedToText = generateAppliedToText(applyBasedOnFulfillmentTypes);
  const subtotalText = generateOrderSubtotalText(applyBasedOnSubtotal, currency);
  const handleWidgetAction = React.useCallback(value => {
    onWidgetAction == null || onWidgetAction(CREATE_SERVICE_FEE_WIDGET_NAME, {
      action: value.buttonName,
      value
    });
  }, [onWidgetAction]);
  return /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Card, {
    showShadow: true,
    stretchVertically: true
  }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "small"
  }, name)), /*#__PURE__*/React.createElement(Box, {
    flexShrink: 1
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, amountText))), /*#__PURE__*/React.createElement(Box, {
    paddingTop: "SP2",
    paddingBottom: "SP2"
  }, /*#__PURE__*/React.createElement(Divider, {
    direction: "horizontal"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    color: "#3B4057"
  }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "small",
    secondary: true
  }, "Applied to:", ' '), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, appliedToText)), subtotalText ? /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "small",
    secondary: true
  }, "Order subtotal:", ' '), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, subtotalText)) : null)))), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    paddingTop: "SP1",
    paddingBottom: "SP1",
    gap: 2
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      handleWidgetAction({
        buttonName: 'save',
        serviceFee
      });
      send(confirmMessage);
    },
    size: "tiny",
    skin: "ai"
  }, saveServiceFeeButtonText), /*#__PURE__*/React.createElement(TextButton, {
    onClick: () => {
      handleWidgetAction({
        buttonName: 'cancel'
      });
      send(cancelMessage);
    },
    size: "tiny"
  }, cancelButtonText)));
};

/*
MESSAGE
<<{
      "widget": "CREATE_SERVICE_FEE",
      "data": {
          "serviceFee": {
            confirmMessage: "Create Service Fee",
            cancelMessage: "Cancel",
            data: {
              name: "Package-free",
              feeAmount: {
                currencyOrPercentage: "currency",
                price: "33",
              },
              applyBasedOnFulfillmentTypes: {
                deliveryOrders: true,
                pickupOrders: false,
              },
              applyBasedOnSubtotal: {
                amount: "55",
              },
            },
          }
      },
  }>>
*/
//# sourceMappingURL=CreateServiceFee.js.map